import { createUseStyles } from 'react-jss'
import { DARK_GRAY_05, GRAY_22 } from '@omnilert/components'

export default createUseStyles({
  container: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 10,
    position: 'relative',

    '&:before': {
      content: '""',
      position: 'absolute',
      top: '50%',
      left: 0,
      borderTop: '1px solid var(--message__indicator__top-border__color)',
      width: '100%',
      transform: 'translateY(-50%)'
    }
  },
  contentContainer: {
    '& svg': {
      height: '12px',
      width: '18px'
    },
    alignItems: 'center',
    background: 'var(--scroll-indicator__background__color)',
    border: `1px solid ${GRAY_22}`,
    borderRadius: '50px',
    boxShadow: `0px 4px 15px ${DARK_GRAY_05}, 0px 2px 4px ${DARK_GRAY_05}`,
    boxSizing: 'border-box',
    color: 'var(--message__indicator__text__color)',
    display: 'flex',
    flexDirection: 'row',
    fontSize: '12px',
    fontWeight: 'bold',
    height: '30px',
    justifyContent: 'center',
    padding: '7px 15px',
    textTransform: 'uppercase',
    top: '0px',
    width: '189px',
    zIndex: 1
  }
})
